import { render, staticRenderFns } from "./video-section.vue?vue&type=template&id=2546cd15&scoped=true&"
import script from "./video-section.vue?vue&type=script&lang=ts&"
export * from "./video-section.vue?vue&type=script&lang=ts&"
import style0 from "./video-section.vue?vue&type=style&index=0&id=2546cd15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546cd15",
  null
  
)

export default component.exports